export function getScriptParams(scriptName, paramsKey) {
    const scripts = document.getElementsByTagName("script");

    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.indexOf("/" + scriptName) !== -1) {
            const pa = scripts[i].src.split("?").pop().split("&");

            const p = {};
            for (let j = 0; j < pa.length; j++) {
                const kv = pa[j].split("=");
                p[kv[0]] = kv[1];
            }
            return p[paramsKey];
        }
    }
    return null;
}

export const isModuleHashValid = async () => {
    const params = getScriptParams("tenjity.js", "uid");
    const formData = new FormData();
    formData.append("hash", params);
    let isValid = false;
    try {
        const response = await fetch(`https://tenjity.lagoon.nc/checkHashCustomer`, {
            method: "post",
            body: formData,
            headers: {
                Authorization: `Basic ${process.env.VUE_APP_API_AUTHORIZATION_TOKEN}`,
            },
        });

        if (!response.ok) {
            throw new Error("Un probleme est survenu lors de la validation de votre module...");
        }

        const data = await response.json();
        isValid = data["Hash_valide"];
    } catch (error) {
        console.log(error.message);
    }
    return isValid;
};

export function addInputClass() {
  const inputs = document.querySelectorAll(
    'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([type="image"]), textarea, [contenteditable="true"]'
  );
  inputs.forEach((input) => {
        input.classList.add("VKInput");

        try {
            const hasAriaLabel = input.hasAttribute && input.hasAttribute('aria-label') && String(input.getAttribute('aria-label')).trim() !== '';
            const hasAriaLabelled = input.hasAttribute && input.hasAttribute('aria-labelledby') && String(input.getAttribute('aria-labelledby')).trim() !== '';
            const hasTitle = input.hasAttribute && input.hasAttribute('title') && String(input.getAttribute('title')).trim() !== '';

            let hasLabel = false;
            const id = input.id || null;
            if (id) {
                hasLabel = !!document.querySelector(`label[for="${id}"]`);
            }
            if (!hasLabel && input.closest) {
                hasLabel = !!input.closest('label');
            }

            if (!hasAriaLabel && !hasAriaLabelled && !hasTitle && !hasLabel) {
                const fallback = input.getAttribute && (input.getAttribute('placeholder') || input.getAttribute('name') || input.type || 'Champ de saisie');
                if (fallback) {
                    input.setAttribute('aria-label', fallback);
                    input.setAttribute('title', fallback);
                } else {
                    input.setAttribute('aria-label', 'Champ de saisie');
                    input.setAttribute('title', 'Champ de saisie');
                }
            }
        } catch (e) {
            // defensive: in some host pages read-only properties may throw
            // ignore and continue
        }
  });
}
